import { render, staticRenderFns } from "./PainelProjetosSeds.vue?vue&type=template&id=625da64a"
import script from "./PainelProjetosSeds.vue?vue&type=script&lang=js"
export * from "./PainelProjetosSeds.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosSeds.vue?vue&type=style&index=0&id=625da64a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports